var storageKey = 'map';

function MapState(view, scope, storage) {
  this.view = view;
  this.scope = scope;
  this.storage = storage;
}

MapState.prototype.save = function() {
  this.storage.session.set(storageKey, {
    routeId: this.routeId(),
    zoom: this.view.getZoom(),
    center: this.view.getCenter()
  });
};

MapState.prototype.remove = function() {
  this.storage.session.remove(storageKey);
};

MapState.prototype.restore = function() {
  var state = this.storage.session.get(storageKey);
  var routeId = (state && +state.routeId) || null;

  if (state && routeId === this.routeId()) {
    this.view.setZoom(state.zoom);
    this.view.setCenter(state.center);
  }
};

MapState.prototype.routeId = function() {
  return this.scope.map.route ? this.scope.map.route.id : null;
};

module.exports = MapState;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/mapState.js
 ** module id = 182
 ** module chunks = 1
 **/